// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"c7ad2b27","3029":"abf91789","3835":"abf91789","4240":"48443644","7296":"c7ad2b27","9620":"abf91789"}[chunkId] + ".chunk.css";
};